(function () {
  if (customElements.get('product-form')) return;

  const fallbackSerializeForm = (form) => {
    const fd = new FormData(form);
    const obj = {};
    for (const [k, v] of fd.entries()) {
      if (obj[k] !== undefined) {
        Array.isArray(obj[k]) ? obj[k].push(v) : (obj[k] = [obj[k], v]);
      } else {
        obj[k] = v;
      }
    }
    return JSON.stringify(obj);
  };

  const fallbackFetchConfig = () => ({
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json'
    },
    credentials: 'same-origin'
  });

  const serialize = (form) =>
    (typeof window.serializeForm === 'function'
      ? JSON.stringify(JSON.parse(window.serializeForm(form))) 
      : fallbackSerializeForm(form));

  const fetchCfg = (type) =>
    (typeof window.fetchConfig === 'function'
      ? window.fetchConfig(type)
      : fallbackFetchConfig());

  // --- element ---
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.cartNotification = document.querySelector('cart-notification');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this), { passive: false });
    }

    onSubmitHandler(e) {
      e.preventDefault();

      const submitBtn = this.querySelector('[type="submit"]');
      const setLoading = (on) => {
        if (!submitBtn) return;
        submitBtn.toggleAttribute('disabled', on);
        submitBtn.classList.toggle('loading', on);
      };

      setLoading(true);

      // If no AJAX cart UI exists, do a classic form submit (works everywhere)
      if (!this.cartNotification) {
        this.form.submit();
        return;
      }

      // Build payload
      let payload;
      try {
        payload = {
          ...JSON.parse(serialize(this.form)),
          sections: this.cartNotification.getSectionsToRender().map((s) => s.id),
          sections_url: window.location.pathname
        };
      } catch (err) {
        console.warn('serialize failed, falling back to full submit:', err);
        this.form.submit();
        return;
      }

      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 8000);

      fetch(`${window.routes?.cart_add_url || '/cart/add.js'}`, {
        ...fetchCfg('javascript'),
        body: JSON.stringify(payload),
        signal: controller.signal
      })
        .then((res) => (res.ok ? res.json() : Promise.reject(res)))
        .then((state) => {
          this.cartNotification.setActiveElement(document.activeElement);
          this.cartNotification.renderContents(state);
        })
        .catch((err) => {
          console.warn('AJAX add-to-cart failed, falling back to normal submit:', err);
          this.form.submit();
        })
        .then(() => { // use .then chain so older webviews that lack .finally still clean up
          clearTimeout(timer);
          setLoading(false);
        });
    }
  });
})();
